import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  events: null,
  current: null,
  applications: null,
  loading: false
}

const organizerSlice = createSlice({
  name: 'organizer',
  initialState,
  reducers: {
    setEvents: (state, action) => ({ ...state, events: action.payload }),
    setCurrent: (state, action) => ({ ...state, current: action.payload }),
    setApplications: (state, action) => ({ ...state, applications: action.payload }),
    setLoading: (state, action) => ({ ...state, loading: action.payload })
  }
})

export const { setEvents, setCurrent, setApplications, setLoading } = organizerSlice.actions
export default organizerSlice.reducer
